import React, { useState } from 'react';
import AiReportsChatDrawer from './AiReportsChatDrawer';

const AiReportsChatLauncher = ({ accountingClientId, username }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <AiReportsChatDrawer
        isOpen={open}
        onClose={() => setOpen(false)}
        accountingClientId={accountingClientId}
        username={username}
      />

      <div className="fixed right-4 bottom-4 md:bottom-6 z-50">
        <div className="group relative">
          <button
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            className="w-14 h-14 rounded-full bg-teal-600 hover:bg-teal-700 text-white shadow-lg flex items-center justify-center ai-reports-pulse"
            aria-label="AI Reports"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-6 h-6">
              <path d="M4 5h16v10H9l-5 4V5z" />
              <path d="M8 9h8" />
              <path d="M8 12h6" />
            </svg>
          </button>

          <div className="absolute right-16 top-1/2 -translate-y-1/2 px-2 py-1 rounded bg-gray-800 text-white text-xs opacity-0 group-hover:opacity-100 transition whitespace-nowrap">
            VentaHub Spark
          </div>
        </div>
      </div>

      <style>{`
        @keyframes aiReportsPulse {
          0% { box-shadow: 0 0 0 0 rgba(13, 148, 136, 0.45); }
          70% { box-shadow: 0 0 0 14px rgba(13, 148, 136, 0); }
          100% { box-shadow: 0 0 0 0 rgba(13, 148, 136, 0); }
        }

        .ai-reports-pulse {
          animation: aiReportsPulse 2s infinite;
        }
      `}</style>
    </>
  );
};

export default AiReportsChatLauncher;
